export const productStructuredData = {
  quickcont: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "QuickCont",
    "description": "Sistema ERP integral que unifica contabilidad, facturación, inventario, nómina y más en una sola plataforma. Con asistente inteligente integrado, reportes personalizados y cumplimiento fiscal automatizado.",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web-based",
    "softwareVersion": "2024.1",
    "datePublished": "2019-01-01",
    "dateModified": "2025-01-01",
    "author": {
      "@type": "Organization",
      "name": "IPSE",
      "url": "https://ipse.com.ec"
    },
    "publisher": {
      "@type": "Organization",
      "name": "IPSE - Ingeniería y Productos de Software Empresarial",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ipse.com.ec/logo.png"
      }
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "Plan Básico",
        "price": "49.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      },
      {
        "@type": "Offer",
        "name": "Plan Profesional",
        "price": "99.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      },
      {
        "@type": "Offer",
        "name": "Plan Empresarial",
        "price": "199.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "150",
      "bestRating": "5",
      "worstRating": "1"
    },
    "featureList": [
      "Contabilidad integral",
      "Facturación electrónica",
      "Control de inventario",
      "Gestión de nómina",
      "Reportes financieros",
      "Asistente inteligente con IA",
      "Cumplimiento fiscal automático",
      "Dashboard personalizable"
    ],
    "screenshot": "https://ipse.com.ec/quickcont-screenshot.jpg",
    "softwareHelp": {
      "@type": "CreativeWork",
      "url": "https://ipse.com.ec/quickcont#soporte"
    },
    "downloadUrl": "https://quickcont.ipse.com.ec",
    "sameAs": [
      "https://quickcont.ipse.com.ec"
    ]
  },

  facelec: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Facelec",
    "description": "Solución completa para facturación electrónica que cumple con todas las normativas del SRI. Automatiza y simplifica tu proceso de facturación con integración contable.",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web-based",
    "softwareVersion": "2024.1",
    "datePublished": "2019-01-01",
    "dateModified": "2025-01-01",
    "author": {
      "@type": "Organization",
      "name": "IPSE",
      "url": "https://ipse.com.ec"
    },
    "publisher": {
      "@type": "Organization",
      "name": "IPSE - Ingeniería y Productos de Software Empresarial",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ipse.com.ec/logo.png"
      }
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "Plan Básico",
        "price": "29.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      },
      {
        "@type": "Offer",
        "name": "Plan Profesional",
        "price": "59.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      },
      {
        "@type": "Offer",
        "name": "Plan Empresarial",
        "price": "119.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.7",
      "reviewCount": "200",
      "bestRating": "5",
      "worstRating": "1"
    },
    "featureList": [
      "Facturación electrónica SRI",
      "Comprobantes de retención",
      "Notas de crédito y débito",
      "Guías de remisión",
      "Integración contable",
      "Reportes fiscales",
      "Envío automático por email",
      "Portal del cliente"
    ],
    "screenshot": "https://ipse.com.ec/facelec-screenshot.jpg",
    "softwareHelp": {
      "@type": "CreativeWork",
      "url": "https://ipse.com.ec/facelec#soporte"
    },
    "downloadUrl": "https://facelec.ipse.com.ec",
    "sameAs": [
      "https://facelec.ipse.com.ec"
    ]
  },

  galenos: {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Galenos Web",
    "description": "Sistema integral para la gestión de clínicas y consultorios médicos. Optimiza agendas, expedientes clínicos y procesos administrativos en una plataforma segura.",
    "applicationCategory": "MedicalApplication",
    "operatingSystem": "Web-based",
    "softwareVersion": "2024.1",
    "datePublished": "2020-01-01",
    "dateModified": "2025-01-01",
    "author": {
      "@type": "Organization",
      "name": "IPSE",
      "url": "https://ipse.com.ec"
    },
    "publisher": {
      "@type": "Organization",
      "name": "IPSE - Ingeniería y Productos de Software Empresarial",
      "logo": {
        "@type": "ImageObject",
        "url": "https://ipse.com.ec/logo.png"
      }
    },
    "offers": [
      {
        "@type": "Offer",
        "name": "Plan Individual",
        "price": "79.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      },
      {
        "@type": "Offer",
        "name": "Plan Clínica",
        "price": "149.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      },
      {
        "@type": "Offer",
        "name": "Plan Hospital",
        "price": "299.99",
        "priceCurrency": "USD",
        "billingIncrement": "P1M",
        "priceValidUntil": "2025-12-31",
        "availability": "https://schema.org/InStock",
        "validFrom": "2025-01-01"
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "85",
      "bestRating": "5",
      "worstRating": "1"
    },
    "featureList": [
      "Historia clínica electrónica",
      "Gestión de citas médicas",
      "Control de inventario médico",
      "Facturación médica",
      "Reportes especializados",
      "Gestión de pacientes",
      "Agenda médica",
      "Integración con equipos médicos"
    ],
    "screenshot": "https://ipse.com.ec/galenos-screenshot.jpg",
    "softwareHelp": {
      "@type": "CreativeWork",
      "url": "https://ipse.com.ec/galenos#soporte"
    },
    "downloadUrl": "https://galenos.ipse.com.ec",
    "sameAs": [
      "https://galenos.ipse.com.ec"
    ]
  }
};

export const getProductStructuredData = (product: keyof typeof productStructuredData) => {
  return productStructuredData[product];
};
